export const HEADER_UI_API_PATHS = {
  openAuthModalV2: '/v2/open-auth-modal/',
  setRegionIdV2: '/v2/set-region-id/',
  updateHeaderV2: '/v2/update-header/',
  openAuthModalV3: '/v3/open-auth-modal/',
  setRegionIdV3: '/v3/set-region-id/',
  updateHeaderV3: '/v3/update-header/',
} as const;

export type THeaderUIAPIPath = (typeof HEADER_UI_API_PATHS)[keyof typeof HEADER_UI_API_PATHS];
